module.exports = __webpack_public_path__ + "62a9a58cbddcc5b3ce2c5ce0d364d90d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/quaker.png
// module id = 1912
// module chunks = 0